import { useCallback, useState } from 'preact/hooks'

import type { CookieConsentEngine } from '#src/assets/ui/mount/cookieConsentEngine.ts'
import type { CookieCategory } from '~/src/services/cookieTranslationService/types.ts'

export function useCookieCategoryState({
  engine,
  configuredCategories,
}: {
  engine: CookieConsentEngine
  configuredCategories: CookieCategory[]
}) {
  const buildInitialCategoryState = useCallback(
    ({
      engine,
      configuredCategories,
    }: {
      engine: CookieConsentEngine
      configuredCategories: CookieCategory[]
    }): Record<string, boolean> => {
      const accepted = new Set(engine.getAcceptedCategories())

      return Object.fromEntries(
        configuredCategories.map(category => [
          category,
          category === 'necessary' ? true : accepted.has(category),
        ]),
      )
    },
    [],
  )

  const [categoryState, setCategoryState] = useState<Record<string, boolean>>(
    () => buildInitialCategoryState({ engine, configuredCategories }),
  )

  return { categoryState, setCategoryState, buildInitialCategoryState }
}
